import { createRouter, createWebHistory } from 'vue-router'
import { hasLogin, loadUser } from '@/composables/useUserSession'

import { siteReady, updateSiteTitle } from '@/composables/useSiteConfig'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    { path: '/login/transfer', name: 'login-transfer', component: () => import('@/views/auth/LoginTransfer.vue'), meta: { title: '登录' } },
    {
      path: '/member',
      meta: { requiresAuth: true },
      component: () => import('@/layouts/MemberLayout.vue'),
      children: [
        {
          path: 'warehouses',
          name: 'member-warehouses',
          component: () => import('@/views/member/Warehouses.vue'),
          meta: { title: '仓库服务' },
        },
        {
          path: 'account/upgrade',
          name: 'member-upgrade',
          component: () => import('@/views/member/AccountPlaceholder.vue'),
          meta: { title: '会员升级' },
        },
        {
          path: 'account/profile',
          name: 'member-profile',
          component: () => import('@/views/member/AccountPlaceholder.vue'),
          meta: { title: '资料设置' },
        },
        {
          path: 'account/notifications',
          name: 'member-notifications',
          component: () => import('@/views/member/AccountPlaceholder.vue'),
          meta: { title: '消息通知' },
        },
        {
          path: 'account/password',
          name: 'member-password',
          component: () => import('@/views/member/AccountPlaceholder.vue'),
          meta: { title: '登录密码' },
        },
        {
          path: 'account/freeze',
          name: 'member-freeze',
          component: () => import('@/views/member/AccountPlaceholder.vue'),
          meta: { title: '冻结账号' },
        },
        {
          path: 'account/cancel',
          name: 'member-cancel-account',
          component: () => import('@/views/member/AccountPlaceholder.vue'),
          meta: { title: '注销账号' },
        },
        {
          path: 'account/feedback',
          name: 'member-feedback',
          component: () => import('@/views/member/AccountPlaceholder.vue'),
          meta: { title: '投诉建议' },
        },
        {
          path: 'finance/transactions',
          name: 'member-transactions',
          component: () => import('@/views/member/Transactions.vue'),
          meta: { title: '收支明细' },
        },
        {
          path: 'finance/recharge',
          name: 'member-recharge',
          component: () => import('@/views/member/Recharge.vue'),
          meta: { title: '账户充值' },
        },
        {
          path: 'after-sales',
          name: 'member-after-sales',
          component: () => import('@/views/member/AfterSales.vue'),
          meta: { title: '售后订单' },
        },
        {
          path: 'service-orders',
          name: 'member-service-orders',
          component: () => import('@/views/member/ServiceOrders.vue'),
          meta: { title: '服务订单' },
        },
        {
          path: 'reshipment',
          name: 'member-reshipment',
          component: () => import('@/views/member/Reshipment.vue'),
          meta: { title: '二次发货' },
        },
        {
          path: 'orders',
          name: 'member-orders',
          component: () => import('@/views/member/Orders.vue'),
          meta: { title: '发货订单' },
        },
        {
          path: 'inventory',
          name: 'member-inventory',
          component: () => import('@/views/member/Inventory.vue'),
          meta: { title: '库存管理' },
        },
        {
          path: '',
          name: 'member-center',
          component: () => import('@/views/member/Center.vue'),
          meta: { title: '会员中心' },
        },
        {
          path: 'shops',
          name: 'member-shops',
          component: () => import('@/views/member/Shops.vue'),
          meta: { title: '店铺列表' },
        },
      ],
    },
    {
      path: '/download',
      name: 'download',
      component: () => import('@/views/Download.vue'),
      meta: { title: '下载客户端' },
    },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: { title: '首页' },
    },
    {
      path: '/account',
      component: () => import('@/layouts/AuthLayout.vue'),
      children: [
        { path: '', redirect: { name: 'login' } },
        {
          path: '/login',
          name: 'login',
          component: () => import('@/views/auth/Login.vue'),
          meta: { title: '登录' },
        },
        {
          path: '/register',
          name: 'register',
          component: () => import('@/views/auth/Register.vue'),
          meta: { title: '注册' },
        },
        {
          path: '/forgot-password',
          name: 'forgot-password',
          component: () => import('@/views/auth/ForgotPassword.vue'),
          meta: { title: '找回密码' },
        },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: { name: 'login' } },
  ],
  scrollBehavior(to) {
    if (to.hash && to.name !== 'login-transfer') return { el: to.hash }
    return { top: 0 }
  },
})
let authChecks = 0
window.addEventListener('weijie-auth-expired', () => {
  if (!authChecks && router.currentRoute.value.meta.requiresAuth) router.replace({ name: 'login' })
})
router.beforeEach(async (to) => {
  if (!(await siteReady)) return false
  if (to.name === 'home') {
    if (hasLogin.value) loadUser().catch(() => {})
    return true
  }
  if (to.meta.requiresAuth || to.name === 'login') {
    authChecks += 1
    try {
      await loadUser()
      if (to.name === 'login') return { name: 'member-center' }
    } catch (error) {
      if (error.code === 'LOGIN_REDIRECT') return false
      if (to.meta.requiresAuth) return { name: 'login' }
    } finally {
      authChecks -= 1
    }
  }
  return true
})
router.afterEach((to) => {
  updateSiteTitle(to.meta.title, to.name === 'home')
})
export default router
